import joi from 'joi';
import { $bool } from '@loyalty/shared-common/zod';
import { z } from 'zod';
import {
  $addIncomingWebhookBody as $eventProcessingAddIncomingWebhookBody,
  $updateIncomingWebhookBody as $eventProcessingUpdateIncomingWebhookBody,
  AddIncomingWebhookBody as EventProcessingAddIncomingWebhookBody,
  IncomingEventProcessingWebhookAttributes as EventProcessingIncomingWebhookAttributes,
  UpdateIncomingWebhookBody as UpdateEventProcessingIncomingWebhookBody,
} from '../../event-processing-api-client';
import {
  $addIncomingWebhookBody as $ingestorAddIncomingWebhookBody,
  $authenticationConfigUnlessIntegration,
  $updateIncomingWebhookBody as $ingestorUpdateIncomingWebhookBody,
  AddIngestorIncomingWebhookBody as IngestorAddIncomingWebhookBody,
  IncomingIngestorWebhookAttributes as IngestorIncomingWebhookAttributes,
  UpdateIngestorIncomingWebhookBody,
} from '../../ingestor-api-client';

export interface DynamicConfiguration {
  cnameDomain: string;
  elasticApmActive: boolean;
  elasticApmServerUrl: string;
  elasticApmEnvironment: string;
  qualifioApiUrl: string;
  microFrontEndsUrls: {
    integrationHub: string;
  };
}

export type AddManagerIncomingWebhookBody = IngestorAddIncomingWebhookBody &
  EventProcessingAddIncomingWebhookBody & { id: string };

const $managerAuthenticationConfig = $authenticationConfigUnlessIntegration('config.integrationId');

export const $addManagerIncomingWebhookBody = joi
  .object<AddManagerIncomingWebhookBody>()
  .concat($ingestorAddIncomingWebhookBody)
  .concat($eventProcessingAddIncomingWebhookBody as any)
  .keys({ authenticationConfig: $managerAuthenticationConfig });

export type UpdateManagerIncomingWebhookBody = UpdateEventProcessingIncomingWebhookBody &
  UpdateIngestorIncomingWebhookBody & { id: string };

export const $updateManagerIncomingWebhookBody = joi
  .object<UpdateManagerIncomingWebhookBody>()
  .concat($ingestorUpdateIncomingWebhookBody)
  .concat($eventProcessingUpdateIncomingWebhookBody as any)
  .keys({ authenticationConfig: $managerAuthenticationConfig });

export type ManagerIncomingWebhookAttributes = IngestorIncomingWebhookAttributes &
  EventProcessingIncomingWebhookAttributes;

export interface UpdateSocialLoginClientBody {
  pageId?: number | null;
  integrationId?: number | null;
}

export interface LoyaltyProgramEmbed {
  script: string;
  webview: string;
  iframe: string;
}

export const $ProfileExportableColumns = z.object({
  general: z.object({
    id: $bool.optional(),
    firstName: $bool.optional(),
    lastName: $bool.optional(),
    email: $bool.optional(),
    language: $bool.optional(),
    gender: $bool.optional(),
    phone: $bool.optional(),
    birthday: $bool.optional(),
  }),
  address: z.object({
    state: $bool.optional(),
    country: $bool.optional(),
    city: $bool.optional(),
    zipCode: $bool.optional(),
    street: $bool.optional(),
    number: $bool.optional(),
    box: $bool.optional(),
  }),
  loyalty: z.object({
    levelName: $bool.optional(),
    referrerId: $bool.optional(),
    rewardsCount: $bool.optional(),
    createdAt: $bool.optional(),
    lastVisit: $bool.optional(),
    referralCode: $bool.optional(),
    memberCode: $bool.optional(),
  }),
});

export const $ExportProfileOptions = z.object({
  columns: $ProfileExportableColumns.optional(),
  relations: z
    .object({
      currencies: z.array(z.string().uuid()).optional(),
      customKeys: z.array(z.string()).optional(),
    })
    .optional(),
});

export type ExportProfileOptions = z.infer<typeof $ExportProfileOptions>;
